<template>
  <div>
    <h2>{{ $t('reportings.list.mainTitle') }}</h2>
    <b-alert v-model="hasError" variant="danger">
      {{ errorMessage }}
    </b-alert>
    <b-row class="mt-4">
      <b-col lg="3" class="mr-auto">
        <dx-select-box
          v-if="reportingGroups"
          :data-source="reportingGroups"
          label-mode="floating"
          label="Select Reporting Group"
          :search-enabled="true"
          value-expr="field_001"
          display-expr="reportingGroups"
          class="my-3"
          :showDataBeforeSearch="true"
          :onValueChanged="selectRG"
          :show-clear-button="true"
        />
      </b-col>
    </b-row>
    <b-row class="mt-4 center row-cards" v-if="calculation.total && fundingsByRG.length > 0" align-h="center">
      <b-col lg="2" class="my-1">
        <b-card align="center" class="clickable" @click="loadStartups" :class="{ active: activeStartups }">
          <b-card-text><strong>{{ calculation.total }}</strong><br>Startups</b-card-text>
        </b-card>
      </b-col>
      <b-col lg="2" class="my-1">
        <b-card align="center" class="clickable" @click="loadExits" :class="{ active: activeExits }">
          <b-card-text><strong>{{ calculation.exits }}</strong><br>Exits</b-card-text>
        </b-card>
      </b-col>
      <b-col lg="2" class="my-1">
        <b-card align="center" class="clickable" @click="loadIPOs" :class="{ active: activeIpo }">
          <b-card-text><strong>{{ calculation.ipo }}</strong><br>IPO's</b-card-text>
        </b-card>
      </b-col>
      <b-col lg="2" class="my-1">
        <b-card align="center">
          <b-card-text><strong>{{ convertFormat(calculation.jobs) }}</strong><br>Jobs</b-card-text>
        </b-card>
      </b-col>
      <b-col lg="2" class="my-1">
        <b-card align="center">
          <b-card-text><strong>{{ convertFormat(calculation.investment) }}</strong><br>CHF Investment</b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <reporting-list :key="componentKey" v-if="(selectedItems && activeExits) || (selectedItems && activeIpo)" :rgFilter="rgFilter" :stageFilter="stageFilter"/>
    <reporting-event-list :key="componentKey" v-if="selectedItems && activeStartups" :rgFilter="rgFilter"/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import DxSelectBox from 'devextreme-vue/select-box'
  import reportingList from '@/components/reportings/ReportingFundingList.vue'
  import reportingEventList from '@/components/reportings/ReportingEventList.vue'
  // import moment from 'moment'

  const getInitialData = () => ({
    calculation: {
      total: null,
      exits: null,
      ipo: null,
      jobs: null,
      investment: null
    }
  })

  export default {
    components: {
      DxSelectBox,
      reportingList,
      reportingEventList
    },
    data () {
      return {
        hasError: false,
        errorMessage: '',
        selectedReportingGroup: null,
        ...getInitialData(),
        activeStartups: false,
        activeExits: false,
        activeIpo: false,
        selectedItems: null,
        rgFilter: undefined,
        stageFilter: undefined,
        componentKey: 0
      }
    },
    created () {
      this.getBasicValues('basicValues/GET_REPORTING_GROUPS', this.reportingGroups)
    },
    methods: {
      loadStartups () {
        this.activeExits = false
        this.activeIpo = false
        this.activeStartups = !this.activeStartups
        this.forceRerender()
      },
      loadExits () {
        this.activeStartups = false
        this.activeIpo = false
        this.activeExits = !this.activeExits
        this.stageFilter = 10
        this.forceRerender()
      },
      loadIPOs () {
        this.activeExits = false
        this.activeStartups = false
        this.activeIpo = !this.activeIpo
        this.stageFilter = 16
        this.forceRerender()
      },
      selectRG (e) {
        this.selectedItems = e.value
        this.reset()
        if (e.value) {
          const rgId = e.value
          this.getFundingsByReportingGroup(rgId)
          this.rgFilter = rgId
        }
        this.forceRerender()
      },
      forceRerender () {
        this.componentKey += 1
      },
      calculationByReportingGroup () {
        if (this.fundingsByRG.length) {
          this.calculation.total = this.fundingsByRG.length
          this.calculation.exits = this.findInvestmentStage(10)
          this.calculation.ipo = this.findInvestmentStage(16)
          this.calculation.jobs = this.totalEmployees()
          this.calculation.investment = this.totalFunding()
        }
      },
      totalFunding () {
        let totalFunding = 0
        for (const el in this.fundingsByRG) {
          if (this.fundingsByRG[el].profile) {
            let total = 0
            // statusId 2 = Closed, InvestmentStage 10 = Trade Sale, InvestmentType 9 = Loan, 15 = Revenue
            this.fundingsByRG[el].profile.cRMFundingProfileV2s.forEach(fund => {
              if (fund.statusId === 2 && fund.investmentsStage !== 10 &&
                ![9, 15].includes(fund.investmentsTypeId)) { (total += fund.moneyinCHF) }
            })
            totalFunding += total
          }
        }
        return Math.round(totalFunding)
      },
      totalEmployees () {
        let totalEmployee = 0
        for (const el in this.fundingsByRG) {
          if (this.fundingsByRG[el].profile) {
            totalEmployee += this.fundingsByRG[el].profile.totalEmployee ? this.fundingsByRG[el].profile.totalEmployee : 0
          }
        }
        return totalEmployee
      },
      findInvestmentStage (investment) {
        let totalInvestment = 0
        for (const el in this.fundingsByRG) {
          if (this.fundingsByRG[el].profile) {
            for (const fun in this.fundingsByRG[el].profile.cRMFundingProfileV2s) {
              if (this.fundingsByRG[el].profile.cRMFundingProfileV2s[fun].investmentsStage === investment && this.fundingsByRG[el].profile.cRMFundingProfileV2s[fun].statusId === 2) {
                totalInvestment++
              }
            }
          }
        }
        return totalInvestment
      },
      convertFormat (val) {
        if (val) {
          var convertedValue = (val).toLocaleString(
            'de-DE',
            { minimumFractionDigits: 0 }
          )
          return convertedValue
        }
      },
      reset () {
        Object.assign(this.$data, getInitialData())
        this.$store.commit('fundings/SET_FUNDINGS_BY_RG', [])
        this.activeStartups = false
        this.activeExits = false
        this.activeIpo = false
        this.rgFilter = undefined
        this.stageFilter = undefined
      },
      async getFundingsByReportingGroup (rgId) {
        this.$Progress.start()
        this.hasError = false
        try {
          const { errors } = await this.$store.dispatch('fundings/GET_FUNDINGS_BY_REPORTINGGROUP', rgId)
          if (errors) throw errors
          this.$Progress.finish()
          this.calculationByReportingGroup()
        } catch (err) {
          this.$Progress.fail()
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          console.error(err)
        }
      },
      async getBasicValues (storePath, storeValue) {
        this.hasError = false
        if (storeValue.length === 0) {
          try {
            const { errors } = await this.$store.dispatch(storePath)
            if (errors) throw errors
          } catch (err) {
            this.hasError = true
            console.error(err)
          }
        }
      }
    },
    computed: {
      ...mapGetters({
        reportingGroups: 'basicValues/REPORTING_GROUPS',
        fundingsByRG: 'fundings/FUNDINGS_BY_RG'
      })
    }
  }
</script>
<style lang="scss" scoped>
.row-cards .card {
  border: 1px solid #337ab7;

  .card-body {
    padding: 0.75rem;
  }

  &.clickable {
    cursor: pointer;

    &:hover {
      background-color: #337ab7;
      color: $white;
      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    }

    &.active {
      background-color: #337ab7;
      color: $white;
      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    }
  }
}
</style>
